import store from '../store/Store';
import { MeetingRequestViewStateHost } from 'owa-meeting-message/lib/store/schema/MeetingRequestViewState';
import ConversationReadingPaneViewState from '../store/schema/ConversationReadingPaneViewState';

/**
 * Get MeetingMessageViewStateHost for the message
 * @param viewState - conversationReadingPaneViewState
 * @param internetMessageId - internetMessageId of the message
 */
export default function getMeetingMessageViewStateHost(
    viewState: ConversationReadingPaneViewState,
    internetMessageId: string
): MeetingRequestViewStateHost {
    if (!!viewState && !!viewState.itemPartsMap) {
        return store.conversationReadingPaneViewState.itemPartsMap.get(internetMessageId);
    } else {
        return null;
    }
}
